// extracted by mini-css-extract-plugin
export default {"container":"S03_Info_container__DYPkT","mockup":"S03_Info_mockup__UqV1A","image":"S03_Info_image__pTtyo","bar":"S03_Info_bar__rkvER","items":"S03_Info_items__ZTpoS"};